import { render } from "./MerchantInformation.vue?vue&type=template&id=68ae9060&scoped=true"
import script from "./MerchantInformation.vue?vue&type=script&lang=js"
export * from "./MerchantInformation.vue?vue&type=script&lang=js"

import "./MerchantInformation.vue?vue&type=style&index=0&id=68ae9060&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ae9060"]])

export default __exports__